import React, { useState } from 'react';
import { Col, Row } from 'reactstrap';
import DebounceTextInput from 'components/DebounseTextInput';
import ErrorBoundary from 'components/common/ErrorBoundary';
import ActiveGradeTable from './components/ActiveGradeTable';
// import AdvancedFilters from 'components/AdvancedFilters';
// import GradeFilter from '../GradeFilter';

// const initialValues = {
//   grade: null,
//   category: null,
// };
const ActiveGrade = ({ handleClickEdit, gradeToggle, gradeActions }) => {
  const [searchString, setSearchString] = useState('');
  // const [filterValue, setFilterValue] = useState([]);
  // const statusFilter = {
  //   key: 'status',
  //   value: 'ACTIVE',
  //   type: 'STRING',
  //   op: 'EQ',
  // };

  // const handleFilters = (val) => {
  //   setFilterValue([
  //     {
  //       key: 'name',
  //       value: val?.grade?.name || '',
  //       type: 'STRING',
  //       op: 'LIKE',
  //     },
  //     {
  //       key: 'name',
  //       value: val?.category?.name || '',
  //       type: 'STRING',
  //       joinAttributeName: 'category',
  //       op: 'LIKE',
  //     },
  //   ]);
  // };

  const handleChange = (value) => {
    setSearchString(value);
  };

  return (
    <ErrorBoundary>
      <div className="products-toolbar">
        <Row>
          {/* <Col sm={6}>
          <AdvancedFilters
            handleFilters={handleFilters}
            initialValues={initialValues}
            id="grade_active"
          >
            <GradeFilter statusFilter={statusFilter} />
          </AdvancedFilters>
        </Col> */}
          <Col sm={6} className="text-end">
            <DebounceTextInput
              onInputChange={handleChange}
              delay={500} // Set your desired delay in milliseconds
              value={searchString}
              placeholder="Search by grade"
              positionTop="-34px"
              positionRight="95px"
              classWrapper="products-search"
            />
          </Col>
        </Row>

        {gradeActions}
        {gradeToggle}

        <ActiveGradeTable
          searchString={searchString}
          handleClickEdit={handleClickEdit}
        />
      </div>
    </ErrorBoundary>
  );
};

export default ActiveGrade;
